import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { IMAGE_BASE_CLASSNAME } from './Constants';
import { createImage } from './Image';
createComponents(".".concat(IMAGE_BASE_CLASSNAME), createImage, NO_PATTERN_BUSINESS_LOGIC);
